import { gql } from "@apollo/client";

export const eventPolicyComplianceDetailFragment = gql`
  fragment eventPolicyComplianceDetailFragment on event_policy_compliance_detail {
    id
    rateStartAt: rate_start_at
    rateEndAt: rate_end_at
    rate
    rateUnit: rate_unit
    price
    currency
    violation
    appliedRate: applied_rate {
      id
      rate
      rateUnit: rate_unit
      incrementDuration: increment_duration
    }
  }
`;

export interface EventPolicyComplianceDetail {
  id: string;
  rateStartAt: string;
  rateEndAt: string;
  rate: number;
  rateUnit: string;
  price: number;
  currency: string;
  violation: boolean;
  appliedRate: {
    id: string;
    rate: number;
    rateUnit: string;
    incrementDuration: number | null;
  } | null;
}
